(() => {
  const ITEM_SELECTOR = '.avis-option-value-item';

  let isAutoSelecting = false;
  let updateTimer = null;

  function normalize(value) {
    return String(value ?? '').trim();
  }

  function getVariants() {
    return window.meta?.product?.variants || [];
  }

  function getVariantOptions(variant) {
    if (variant.public_title) {
      return variant.public_title
        .split(' / ')
        .map(normalize);
    }

    if (variant.name && variant.name.includes(' - ')) {
      return variant.name
        .split(' - ')
        .pop()
        .split(' / ')
        .map(normalize);
    }

    return [];
  }

  function getGroups() {
    const map = new Map();

    document.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
      const input = item.querySelector('input');

      if (!input || !input.name) return;

      if (!map.has(input.name)) {
        map.set(input.name, []);
      }

      map.get(input.name).push(item);
    });

    return [...map.values()];
  }

  function getItemValue(item) {
    const input = item.querySelector('input');

    return normalize(
      item.dataset.value ||
      input?.value ||
      item.textContent
    );
  }

  function getSelectedValue(group) {
    const selected = group.find(
      (item) => item.querySelector('input')?.checked
    );

    return selected ? getItemValue(selected) : '';
  }

  function findItem(group, value) {
    return group.find(
      (item) => getItemValue(item) === normalize(value)
    );
  }

  /*
   * Trova la prima variante REALE Shopify che parte
   * con i valori indicati.
   */
  function findFirstVariant(prefixValues) {
    return getVariants().find((variant) => {
      const options = getVariantOptions(variant);

      return prefixValues.every((value, index) => {
        if (!value) return true;

        return normalize(options[index]) === normalize(value);
      });
    });
  }

  /*
   * Nasconde immediatamente le opzioni incompatibili.
   */
  function updateVisibility() {
    const variants = getVariants();
    const groups = getGroups();

    if (!variants.length || groups.length < 2) return;

    const selectedValues = groups.map(getSelectedValue);

    groups.forEach((group, optionIndex) => {
      if (optionIndex === 0) {
        group.forEach((item) => {
          item.style.removeProperty('display');
        });

        return;
      }

      group.forEach((item) => {
        const candidate = getItemValue(item);

        const prefix = selectedValues
          .slice(0, optionIndex);

        prefix.push(candidate);

        const exists = !!findFirstVariant(prefix);

        if (exists) {
          item.style.removeProperty('display');
        } else {
          item.style.setProperty(
            'display',
            'none',
            'important'
          );
        }
      });
    });
  }

  /*
   * Quando cambia la PRIMA opzione:
   *
   * 1. trova immediatamente la prima variante reale Shopify;
   * 2. nasconde le opzioni incompatibili;
   * 3. seleziona automaticamente i valori corretti
   *    delle opzioni successive.
   */
  function handleFirstOptionChange(clickedItem) {
    if (isAutoSelecting) return;

    const groups = getGroups();

    if (groups.length < 2) return;

    const firstGroup = groups[0];

    if (!firstGroup.includes(clickedItem)) return;

    const firstValue = getItemValue(clickedItem);

    const targetVariant = findFirstVariant([firstValue]);

    if (!targetVariant) return;

    const targetOptions = getVariantOptions(targetVariant);

    /*
     * Nascondiamo SUBITO le combinazioni incompatibili,
     * prima che Aris possa lasciarle visibili barrate.
     */
    groups.forEach((group, optionIndex) => {
      if (optionIndex === 0) return;

      group.forEach((item) => {
        const candidate = getItemValue(item);

        const prefix = [
          firstValue,
          ...targetOptions.slice(1, optionIndex),
          candidate
        ];

        const exists = !!findFirstVariant(prefix);

        if (exists) {
          item.style.removeProperty('display');
        } else {
          item.style.setProperty(
            'display',
            'none',
            'important'
          );
        }
      });
    });

    /*
     * Se le opzioni successive non corrispondono alla
     * prima variante reale, le selezioniamo subito.
     */
    isAutoSelecting = true;

    let delay = 0;

    for (let optionIndex = 1; optionIndex < groups.length; optionIndex++) {
      const targetValue = targetOptions[optionIndex];

      if (!targetValue) continue;

      const targetItem = findItem(
        groups[optionIndex],
        targetValue
      );

      if (!targetItem) continue;

      const input = targetItem.querySelector('input');

      if (!input || input.checked) continue;

      setTimeout(() => {
        input.click();
      }, delay);

      delay += 10;
    }

    setTimeout(() => {
      isAutoSelecting = false;
      updateVisibility();
    }, Math.max(40, delay + 20));
  }

  function scheduleUpdate(delay = 0) {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(() => {
      updateVisibility();
    }, delay);
  }

  /*
   * CAPTURE PHASE:
   * intercettiamo il click prima che Aris completi
   * il proprio rendering.
   */
  document.addEventListener(
    'click',
    (event) => {
      const item = event.target.closest(ITEM_SELECTOR);

      if (!item) return;

      handleFirstOptionChange(item);

      requestAnimationFrame(() => {
        updateVisibility();
      });
    },
    true
  );

  document.addEventListener('change', (event) => {
    if (!event.target.closest(ITEM_SELECTOR)) return;

    requestAnimationFrame(() => {
      updateVisibility();
    });
  });

  /*
   * Aris può ricreare il DOM.
   * Questo serve solamente come fallback.
   */
  const observer = new MutationObserver(() => {
    scheduleUpdate(0);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => updateVisibility()
    );
  } else {
    updateVisibility();
  }

  requestAnimationFrame(() => {
    updateVisibility();
  });
})();